import { cn } from "@/lib/utils";
import { CheckCircle2, MinusCircle, XCircle } from "lucide-react";

type Status = "up" | "down" | string | null | undefined;

interface StatusBadgeProps {
	status: Status;
	className?: string;
	showLabel?: boolean;
}

export function StatusBadge({ status, className, showLabel = true }: StatusBadgeProps) {
	const isUp = status === "up";
	const isDown = status === "down";
	const isUnknown = status !== "up" && status !== "down";

	return (
		<span
			className={cn(
				"inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium",
				isUp && "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
				isDown && "bg-destructive/15 text-destructive",
				isUnknown && "bg-muted text-muted-foreground",
				className,
			)}
		>
			{isUp && <CheckCircle2 className="h-3.5 w-3.5 shrink-0" />}
			{isDown && <XCircle className="h-3.5 w-3.5 shrink-0" />}
			{isUnknown && <MinusCircle className="h-3.5 w-3.5 shrink-0" />}
			{showLabel && <span>{isUp ? "Up" : isDown ? "Down" : "—"}</span>}
		</span>
	);
}
